import React from 'react';
import {ICountdownContainerProps} from '@dazn/lp-web/src/types';
import styles from '@dazn/lp-web/src/components/Countdown/countdown.module.css';

export const CountdownBox: React.FC<ICountdownContainerProps> = ({
    data,
    onClick,
    children
}) => {
    return (
        <div
            id="countdown-box-container"
            style={
                data && data.backgroundColor
                    ? {background: `${data.backgroundColor}`}
                    : {
                          backgroundImage: `url(${data?.backgroundImage?.src})`
                      }
            }
            className={styles.countdownBox}
            onClick={onClick}
        >
            {children}
        </div>
    );
};
